import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';

export namespace IItemPromoPrice {
  /**
   * Return an instance of IItemPromoPrice with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IItemPromoPrice>): IItemPromoPrice =>
    ({
      ...(partial ?? {}),
    }) as IItemPromoPrice;
}

export interface IItemPromoPrice {
  /**
   * Brand promo applied
   * This field is deprecated as it provides no use to FE experiences.
   * See: https://docs.google.com/document/d/1KUvmq65oLUipZE4cXYQAirBSMvDCC_d98Sh7guCD6RM/edit#heading=h.h6yedvqci7l0
   * @deprecated
   */
  brand_promo_token: string | undefined;
  /**
   * Fixed discount percentage on the item
   */
  discount_bps: number | undefined;
  /**
   * Net discounted amount, i.e. originalPrice - discountedItemPrice
   * This property should be computed in FE environments as needed.
   * See: https://docs.google.com/document/d/1KUvmq65oLUipZE4cXYQAirBSMvDCC_d98Sh7guCD6RM/edit#heading=h.h6yedvqci7l0
   * @deprecated
   */
  discount_amount: IFaireMoney | undefined;
  /**
   * Price of the original item pre-discount.
   * Use the sibling field price instead of this field.
   * See: https://docs.google.com/document/d/1KUvmq65oLUipZE4cXYQAirBSMvDCC_d98Sh7guCD6RM/edit#heading=h.h6yedvqci7l0
   * @deprecated
   */
  original_item_price: IFaireMoney | undefined;
  /**
   * The price of this item after item-level discounts are applied to it.
   */
  discounted_item_price: IFaireMoney | undefined;
}
